export default {"src":"/_next/static/media/ColdStack.37048b9c.svg","height":36,"width":174,"blurWidth":0,"blurHeight":0};